/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GenericListPair from 'modules/common/components/GenericListPair';
import useDebounce from 'modules/common/components/UseDebounce';
import * as actions from '../action';
import * as c from '../constant';
import IncidentContent from './IncidentContent';

const form = {
  keyword: '',
  incident_type: '',
  module_type: 'EHELP',
};


function IncidentContainer({
  history,
  match,
  getIncidentList,
  incidentList,
  incidentListPager,
  isLoading,
}) {
  const [formData, setFormData] = useState(form);
  const [filter, setFilter] = useState(form);
  const [countChar, setCountChar] = useState(0);

  const UpdateData = () => {
    getIncidentList()
  };

  const param = {
    module_type: 'EHELP',
    q: formData.keyword,
    sort_by: 'asc',
    incident_type: filter.incident_type,
  };

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    setCountChar(e.target.value.length);
  };

  useEffect(() => {
    UpdateData();
  }, []);

  const handleOnChangeSelect = (key) => (e) => {
    setFilter({
      ...filter,
      [key]: e.value,
      incident_type: e.value,
    });
    getIncidentList({ ...filter, incident_type: e.value });
  };

  const debouncedSearchTerm = useDebounce(formData, 500);
  useEffect(() => {
    if (debouncedSearchTerm && countChar >= 3) {
      getIncidentList({ module_type: 'EHELP', q: formData.keyword });
    } else {
      getIncidentList({ module_type: 'EHELP' });
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:id?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName=""
            getData={getIncidentList}
            setParams={param}
            setKeyword={handleOnChange}

            setStatusFilter={handleOnChangeSelect(
              _.get(formData, 'incident_type')
            )}
            status={_.get(filter, 'incident_type') || ''}
            keyword={_.get(formData, 'keyword') || ''}

            keywordPlaceholder="Search Incident Reports"
            pathName={`${match.path}/:id?`}
            // listName="Transaction"
            label="Incident List"
            // LEFT SECTION
            renderItem={(item) => (
              <div className="px-3 py-3">
                <div className="registered-citizen-list">
                  { _.get(item, 'attributes.reporter_name') || '- -' }
                </div>
                <h4 className="mt-1 mb-0 incident-report-list-numbers">
                  {' '}{_.get(item, 'attributes.contact_number')}{' '}
                </h4>
              </div>  
            )}
            isLoading={isLoading}
            // statusFilter
            selected={params.id}
            data={incidentList}
            dataPager={incidentListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            // RIGHT SECTION
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:id?`}
                    render={() => (
                      <IncidentContent
                        UpdateData={UpdateData}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:id?`}
                  render={() =>
                    !params.id && incidentList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(incidentList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

IncidentContainer.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  getIncidentList: PropTypes.instanceOf(Function).isRequired,
  incidentList: PropTypes.instanceOf(Array).isRequired,
  incidentListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  incidentList: _.get(api, `${c.GET_INCIDENT}.list`) || [],
  incidentListPager: _.get(api, `${c.GET_INCIDENT}.pager`) || {},
  isLoading: api.loading.indexOf(c.GET_INCIDENT) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(IncidentContainer);